export const products = [
  {
    id: 'prod_budget',
    slug: 'budget-management',
    name: 'XDigital Budget Management System',
    tagline: 'AI-Powered Financial Planning',
    description:
      'Transform your finance department with AI-powered budget management. Our system uses advanced machine learning to predict cash flows, detect anomalies, and automate budget reallocations in real-time.',
    features: [
      'AI-powered cash flow prediction',
      'Real-time anomaly detection',
      'Automated budget reallocation',
      'SAP, Oracle, Excel integration',
      'Multi-currency support',
    ],
    target_market: 'Large corporations, financial institutions',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/budget-system',
    price_from: 50000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_audit',
    slug: 'audit-management',
    name: 'XDigital Audit Management System',
    tagline: 'AI-Powered Audit Platform',
    description:
      'Process thousands of documents per hour with near-perfect accuracy. Our AI-driven audit system ensures compliance across multiple frameworks while reducing manual effort by 80%.',
    features: [
      'High-volume document processing',
      'Multi-framework compliance',
      'Risk-scoring and recommendations',
      'Automated report generation',
    ],
    target_market: 'Banks, insurance companies, enterprises',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/audit-system',
    price_from: 100000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_realestate',
    slug: 'real-estate-valuation',
    name: 'XDigital Real Estate Valuation System',
    tagline: 'AI-Powered Property Valuations',
    description:
      'Accurate property valuations powered by AI. Get reliable, defensible valuations in minutes instead of days with our satellite imagery analysis and market data integration.',
    features: [
      'Faster AI-powered valuations',
      'Satellite imagery analysis',
      'Market data integration',
      'Confidence scoring',
    ],
    target_market: 'Banks, developers, appraisers',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/realestate-valuation',
    price_from: 5000,
    price_to: 50000,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_reports',
    slug: 'report-generator',
    name: 'XDigital Report Generator System',
    tagline: 'AI-Powered Report Writing',
    description:
      'Transform data into beautiful, insightful reports. Our AI writes executive summaries, creates visualizations, and schedules distribution automatically.',
    features: [
      'Natural language generation',
      'Executive summaries',
      'Custom visualizations',
      'Scheduled distribution',
    ],
    target_market: 'Executives, finance teams',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/report-generator',
    price_from: 5000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_documents',
    slug: 'document-management',
    name: 'XDigital Document Management System',
    tagline: 'Smart Document Platform',
    description:
      'AI-powered document understanding and retrieval. Our system semantically understands your documents, automatically classifies them, and provides instant full-text search.',
    features: [
      'Semantic understanding',
      'Automated classification',
      'Full-text search',
      'Version control',
    ],
    target_market: 'Legal firms, healthcare, enterprises',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/document-management',
    price_from: 30000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_tracker',
    slug: 'asset-tracker',
    name: 'XDigital Tracker System',
    tagline: 'AI-Powered Tracking & Logistics',
    description:
      'Optimize deliveries with AI-powered tracking. Our system provides real-time tracking, predictive maintenance alerts, and route optimization for maximum efficiency.',
    features: [
      'AI-powered route optimization',
      'Real-time tracking',
      'Predictive maintenance',
      'Route optimization',
    ],
    target_market: 'Logistics, manufacturing',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/tracker-system',
    price_from: 20000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_receptionist',
    slug: 'ai-receptionist-agent',
    name: 'XDigital AI Receptionist Agent',
    tagline: '24/7 AI-Powered Call Handling',
    description:
      "An AI agent that answers phone calls and handles inquiries just like a trained receptionist — for hotels, clinics, offices, and any business that receives calls daily.",
    features: [
      'Answers calls 24/7 with natural conversation',
      'Handles bookings, scheduling, and FAQs',
      'Speaks 20+ languages fluently',
      'Zero labor cost — replaces full-time reception staff',
      'Seamless handoff to human agents when needed',
    ],
    target_market: 'Hotels, clinics, offices, resorts, service businesses',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/ai-receptionist-agent',
    price_from: 15000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_techsupport',
    slug: 'ai-technical-support-agent',
    name: 'XDigital AI Technical Support Agent',
    tagline: 'Intelligent Customer Support 24/7',
    description:
      'An AI agent that provides real-time technical support for banks, telecom companies, and any business with complex customer service needs.',
    features: [
      'Handles loans, credit cards, and account support',
      'Step-by-step troubleshooting like a human agent',
      'Available 24/7 — no waiting in queue',
      'Proficient in multiple languages',
      'Escalation to human agents for complex cases',
    ],
    target_market: 'Banks, telecom, insurance, SaaS, tech companies',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/ai-technical-support-agent',
    price_from: 20000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_sales_agent',
    slug: 'ai-sales-agent',
    name: 'XDigital AI Sales Agent',
    tagline: 'AI-Powered Sales Outreach 24/7',
    description:
      'An AI agent that calls prospects, promotes your products, and builds connections — converting leads into clients at a fraction of the cost of traditional marketing campaigns.',
    features: [
      'Calls prospects and promotes products naturally',
      'Books appointments and schedules discovery calls',
      'Works 24/7 — no salaries or commissions',
      'Cost-effective alternative to marketing campaigns',
      'Lead qualification and CRM integration',
    ],
    target_market: 'Real estate, insurance, SaaS, e-commerce, any sales team',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/ai-sales-agent',
    price_from: 15000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_chatbot',
    slug: 'ai-chatbot',
    name: 'XDigital AI Chatbot',
    tagline: 'Intelligent Conversational AI',
    description:
      'Not your typical scripted chatbot. This AI chatbot understands your products, accesses real-time inventory and pricing data, processes payments, and provides intelligent support.',
    features: [
      'Accesses real product data — pricing, inventory, specs',
      'Processes payments directly within the chat',
      'Provides intelligent support — not scripted',
      'Available 24/7 on website, app, or social media',
      'Multi-language support',
    ],
    target_market: 'E-commerce, restaurants, retail, service businesses',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/ai-chatbot',
    price_from: 10000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
  {
    id: 'prod_project',
    slug: 'project-management',
    name: 'XDigital Project Management System',
    tagline: 'AI-Powered Project Intelligence',
    description:
      'An AI-powered project management platform that helps teams plan, track, and deliver projects on time. Uses AI to predict delays, allocate resources, and generate progress reports automatically.',
    features: [
      'AI-powered timeline and resource planning',
      'Predictive delay detection and risk alerts',
      'Automated progress reports and dashboards',
      'Team collaboration and task management',
      'Integration with existing tools and workflows',
    ],
    target_market: 'Construction, IT, agencies, enterprises',
    icon_url: null,
    demo_url: 'https://demo.xdigital.com.ph/project-management',
    price_from: 25000,
    price_to: null,
    show_price: false,
    show_price_public: false,
    is_visible: true,
    is_active: true,
  },
];

export const visibleProducts = products.filter((p) => p.is_visible && p.is_active);

export default products;
